import { render, staticRenderFns } from "./companyReport.vue?vue&type=template&id=13194ac4&scoped=true"
import script from "./companyReport.vue?vue&type=script&lang=js"
export * from "./companyReport.vue?vue&type=script&lang=js"
import style0 from "./companyReport.vue?vue&type=style&index=0&id=13194ac4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13194ac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13194ac4')) {
      api.createRecord('13194ac4', component.options)
    } else {
      api.reload('13194ac4', component.options)
    }
    module.hot.accept("./companyReport.vue?vue&type=template&id=13194ac4&scoped=true", function () {
      api.rerender('13194ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/companyReport.vue"
export default component.exports